import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { setOrgLocale } from "../lib/locale";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setOrgLocale(data?.org);
      setSession(data);
      return data;
    } catch (e) {
      setSession(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (session && session.org) { setOrgLocale(session.org); }
  }, [session]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setSession(false);
  };

  return <AuthCtx.Provider value={{ session, setSession, refresh, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function canWrite(session) {
  if (session?.user?.support) return true;
  const st = session?.access?.state;
  return (st === "trial" || st === "active") && session?.user?.role !== "read_only";
}
